module.exports = __webpack_public_path__ + "static/img/phone-01-copy-8.06dbd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/phone-01-copy-8.png
// module id = G/m2
// module chunks = 1